export default __webpack_public_path__ + "static/media/bbl.88f3b91e.svg";